import React from 'react';

class SearchForm extends React.Component {
    render() {
        return (
            <li>
                <form className="navbar-form">
                    <div className="form-group">
                        <input type="text" className="form-control" placeholder="검색" />
                        <button type="submit" className="btn btn-search"><i className="fa fa-search"></i></button>
                    </div>
                </form>
            </li>
        );
    }
};

export default SearchForm;



// WEBPACK FOOTER //
// ./src/components/admin/header/search/form.js